export default __webpack_public_path__ + "static/media/Ring of Skelos.ee90dea6.jpg";